import React from "react";
import { Card, CardContent, CardHeader, CardTitle } from "components/ui";
import { ReadMore, SmartImage } from "components/atoms";
import BlankImage from "assets/images/PNG/blank.png";
import { openAdminModal } from "store/slices/common/adminModal.slice";
import ModalRejectImage from "components/molecules/ModalRejectImage";
import { useDispatch } from "react-redux";
import { ImageStatusManage } from "store/middlewares/user";
import { openFullScreenModal } from "store/slices/common/fullScreenMedia.slice";
import { Check, Eye, X } from "lucide-react";

const UserMorePhotos = ({ morePhotoInfo }) => {
  const dispatch = useDispatch();
  return (
    <div>
      <Card className="min-w-full">
        <CardHeader>
          <CardTitle>More Photos</CardTitle>
        </CardHeader>

        <CardContent className="p-2">
          {/* Privacy */}
          <div className="flex gap-2 w-full">
            <p className="text-sm text-secondary-foreground">
              Privacy options :
            </p>
            <p className="text-sm text-[#2d2a33] font-semibold capitalize">
              {morePhotoInfo?.imgType ?? "N/A"}
            </p>
          </div>

          {/* Description */}
          <div className="flex gap-2 w-full mb-4">
            <p className="text-sm text-secondary-foreground shrink-0">
              Photo description (Optional) :
            </p>
            <p className="text-sm text-[#2d2a33] font-semibold text-start break-all">
              <ReadMore comment={morePhotoInfo?.description ?? "N/A"} />
            </p>
          </div>

          {/* Images */}
          {morePhotoInfo?.userImages?.length > 0 && (
            <div className="flex flex-wrap gap-4 items-start">
              {morePhotoInfo?.userImages?.map((item, index) => {
                const status = item?.status || "pending";

                return (
                  <Card
                    key={index}
                    className={"rounded-xl overflow-hidden w-72"}
                  >
                    <div className="relative group w-72 h-72  bg-gray-100 overflow-hidden">
                      {/* Image */}
                      <SmartImage
                        size={300}
                        src={item.imageUrl}
                        alt="User"
                        className="w-full h-full object-cover object-center"
                        fallback={
                          <img
                            src={BlankImage}
                            alt="dummyImg"
                            className="w-full h-full object-cover object-center"
                          />
                        }
                      />

                      {/* STATUS BADGE (visible when NOT hovering) */}
                      <div className="absolute top-2 left-2 group-hover:hidden">
                        <span
                          className={`px-3 py-1 text-xs rounded-full text-white capitalize font-semibold
                          ${
                            status === "approved"
                              ? "bg-green-500"
                              : status === "rejected"
                                ? "bg-red-500"
                                : "bg-purple-500"
                          }`}
                        >
                          {status}
                        </span>
                      </div>

                      {/* HOVER OVERLAY (only if NOT approved) */}
                      {status !== "approved" && (
                        <div className="absolute inset-0 bg-black/50 opacity-0 group-hover:opacity-100 transition flex items-center justify-center gap-3">
                          <button
                            onClick={() =>
                              dispatch(
                                openFullScreenModal({
                                  imageSrc: item?.imageUrl,
                                  type: "image",
                                }),
                              )
                            }
                            className="px-2 py-1 bg-blue-500 text-white rounded-sm text-sm hover:bg-blue-600 font-semibold"
                          >
                            <Eye />
                          </button>
                          <button
                            onClick={() => {
                              dispatch(
                                ImageStatusManage({
                                  id: item?.id,
                                  status: "approved",
                                }),
                              );
                            }}
                            className="px-2 py-1 bg-green-500 text-white rounded-sm text-sm hover:bg-green-600 font-semibold"
                          >
                            <Check />
                          </button>
                          {status !== "rejected" && (
                            <button
                              onClick={() => {
                                dispatch(
                                  openAdminModal({
                                    title: "Reject Image",
                                    content: (
                                      <ModalRejectImage
                                        id={item?.id}
                                        imageType={"image"}
                                      />
                                    ),
                                  }),
                                );
                              }}
                              className="px-2 py-1 bg-red-500 text-white rounded-sm text-sm hover:bg-red-600 font-semibold"
                            >
                              <X />
                            </button>
                          )}
                        </div>
                      )}
                    </div>
                    {item?.reason && (
                      <span className="text-sm font-semibold text-red-500 py-2 break-all text-left px-2">
                        <ReadMore
                          comment={`Image rejected due to ${item?.reason} reason`}
                          maxChar={50}
                        />
                      </span>
                    )}
                  </Card>
                );
              })}
            </div>
          )}
        </CardContent>
      </Card>
    </div>
  );
};

export default UserMorePhotos;
